<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Proyectos</li>
                <li class="breadcrumb-item active" aria-current="page">Proyectos Aprobados</li>
            </ol>
        </nav>

        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 mb-4">
                    <vx-card>
                        <h1 class="bold big-title m-0">Proyectos <span>aprobados</span>.</h1>
                    </vx-card>
                </div>

                <div class="col-md-12 mb-4">
                    <vx-card style="z-index: 5 !important;" >
                        <vs-table ref="table" stripe search pagination max-items="15" :data="projects" noDataText="No hay datos disponibles">
                            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mt-4"><h5>Lista de proyectos aprobados (project.status = 4)</h5></div>
                            <template slot="thead">
                                <vs-th v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                <vs-td>
                                    <router-link :to="`/project/${tr.project_id}`">
                                        <strong>{{ tr.alias}} | {{ tr.project_id }}</strong>
                                    </router-link>
                                </vs-td>

                                <vs-td>
                                    <vs-chip :color="getChipClass(tr.person_type)">{{tr.person_type}}</vs-chip>
                                </vs-td>

                                <vs-td>
                                    <strong>{{tr.client.name}} | {{tr.client.id}}</strong>
                                    <br> {{tr.client.email}}
                                    <br> <vs-chip color="success" v-if="tr.hasWpPhone"><span>WhatsApp</span></vs-chip> Tel: {{phoneFormat(tr.client.phone)}}
                                    <br>
                                    <div class="clickable" @click.stop="currentLead = tr.potential_applicant, popupActivo = true">
										<vs-chip v-if="tr.potential_applicant" color="#f44336">
											<strong>{{ tr.potential_applicant.program_info.name }}</strong>
										</vs-chip>
									</div>
                                </vs-td>
                                <vs-td>
                                    <strong>{{tr.supplier !== null ? tr.supplier.tradename + "|" + tr.supplier.id : "--"}}</strong>
                                    <br> {{tr.supplier !== null ? tr.supplier.email : "--"}}
                                    <br>
                                    <div v-if="tr.supplier != null" class="clickable" @click="showSupplierInformation(tr.supplier.id)">
                                        <vs-chip transparent color="warning">
                                            <span class="bold text-xs">Ver informacion del proveedor</span>
                                        </vs-chip>
                                    </div>
                                    <supplier-agent-information :projectId="tr.project_id"></supplier-agent-information>
                                </vs-td>
                                <vs-td>
                                    <vs-chip :color="calculateChipClass(tr.due_days)"><strong>{{tr.due_days}}</strong></vs-chip>
                                    <vs-chip v-if="tr.due_days > dueLimit" :color="calculateChipClass(tr.due_days)"><strong>{{calculateDueDays(tr.due_days)}}</strong></vs-chip>
                                </vs-td>
                                <vs-td>
                                    {{ tr.credit_acceptance_date ? regularDateFormat(tr.credit_acceptance_date) : "--"}}
                                </vs-td>
                                <vs-td>
                                    <div class="row ml-2">
                                        <div class="col-md-2"> 
                                             <vx-tooltip
                                                color="primary"
                                                position="top"
                                                style="float:right;cursor:pointer;margin-top:-8px"
                                                text="Bitácora">
                                                <vs-button color="primary" type="filled" icon="announcement" @click="showProjectMessages(tr.project_id)"></vs-button>
                                            </vx-tooltip>
                                        </div>
                                        
                                        <div class="col-md-2 fix-btn"> 
                                            <project-archive-button @on-save="getProjects()" :project="setProjectInformation(tr)"></project-archive-button>
                                        </div>
                                    </div>
                                </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vx-card>
                </div>
            </div>
        </div>


        <!-- SUPPLIER INFORMATION -->
        <vs-popup title="Información del Proveedor" :active.sync="showFormPromptSupplierInfo">
            <supplier-details v-if="currentSupplierID !== null" ref="supplierDetails" :supplier_id="currentSupplierID"></supplier-details>
        </vs-popup>

        <!-- MESSAGES -->
        <vs-popup title="Mensajero" :active.sync="showFormPromptMessages">
            <project-message-logger ref="projectMessage"></project-message-logger>
        </vs-popup>

        <!-- INFORMACIÓN DE PROGRAMA -->
		<vs-popup v-if="currentLead" class="mid-popup header-primary" title="Detalle del lead de programa"
			:active.sync="popupActivo">
			<vx-card>
				<h3>Información</h3>
				<div class="vx-row">
					<div class="vx-col w-full">
						<p class="bold">Cliente: </p> <span>{{ currentLead.customer_uid }} | {{ currentLead.customer_name
						}}</span> <br>
						<p class="bold">Zona | Región: </p> <span> {{ getZone(currentLead) }} | {{ getRegion(currentLead)
						}}</span> <br>
					</div>
				</div>
			</vx-card>
		</vs-popup>

    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper";
import dateHelper from "@mixins/dateHelper";
import SupplierDetails from "./process-flow/SupplierDetails";
import SupplierAgentInformation from "@projects/SupplierAgentInformation";
import ProjectMessageLogger from "../../../components/ProjectMessageLogger";
import ProjectArchiveButton from "../../../components/project-details/ProjectArchiveButton";

const columns = [
    { title: "PROYECTO", key: "pid", sortable: true}
    , { title: "TIPO DE PERSONA", key: "person_type", sortable: false}
    , { title: "CLIENTE", key: "applicant", sortable: false}
    , { title: "PROVEEDOR", key: "supplier", sortable: false}
    , { title: "DÍAS RESTANTES", key: "due_date", sortable: false}
    , { title: "FECHA DE ACEPTACIÓN", key: "credit_acceptance_date", sortable: false}
    , { title: "ACCIONES", key: "actions", sortable: false}
];
const dueLimit = 30;
    export default {
        name: "ProjectApproved",
        mixins: [formatHelper, dateHelper],
        components: {
            SupplierAgentInformation,
            SupplierDetails,
            ProjectMessageLogger,
            ProjectArchiveButton
        },
        data() {
            return {
                projects: [],
                columns: columns,
                currentSupplierID: null,
                showFormPromptSupplierInfo: false,
                dueLimit:dueLimit,
                showFormPromptMessages: false
                , popupActivo: false
			    , currentLead: null
            }
        },
        mounted () {
            this.getProjects();
        },
        methods:{
            async getProjects(){
                this.showLoading(true);
                try {
                    const res = await axios.get(`/api/projects/approved`);
                    this.projects = res.data;
                } catch (error) {
                    console.warn(error);
                }
                this.showLoading(false);
            },
            getChipClass(person_type){
                if(person_type === "PM"){
                    return "#7e57c2";
                } else if (person_type === "PF"){
                    return "#1976d2"
                } else {
                    return "#1976d2"
                }
            },
            showSupplierInformation(sid){
                this.currentSupplierID = sid;
                this.showFormPromptSupplierInfo = true;
                this.$refs.supplierDetails.update(sid);
                this.$refs.supplierDetails.getSupplierAgents(sid);
            },
            showProjectMessages(pid){
                this.showFormPromptMessages = true;
                this.$refs.projectMessage.setProjectId(pid);
                this.$refs.projectMessage.getNotes(pid);
            },
            setProjectInformation(item){
                return {
                    id: item.project_id
                    , status: item.status
                    , resolution_date: item.resolution_date
                }
            },
            calculateDueDays(dueDays){
                let result = "";
                if(dueDays > this.dueLimit){
                    result += 'Expirado';
                }

                return result;
            },
            calculateChipClass(dueDays){
                if(dueDays > this.dueLimit){
                    return "danger";
                }
                return "primary";
            },
            getZone(pgmApplicant) {
                if (pgmApplicant.subregion_manager_id !== null
                    && pgmApplicant.subregion_manager.region_manager_id !== null
                    && pgmApplicant.subregion_manager.region_manager.zone_manager_id !== null
                    && pgmApplicant.subregion_manager.region_manager.region !== null
                    && pgmApplicant.subregion_manager.region_manager.region.zone !== null
                ) {
                    return pgmApplicant.subregion_manager.region_manager.region.zone.name;
                }
            },
            getRegion(pgmApplicant) {
                if (pgmApplicant.subregion_manager_id !== null
                    && pgmApplicant.subregion_manager.region_manager_id !== null
                    && pgmApplicant.subregion_manager.region_manager.region !== null
                ) {
                    return pgmApplicant.subregion_manager.region_manager.region.name;
                }
            },
        }
    }
</script>

<style scoped>

.fix-btn {
    top: -7px;
    margin-left: -1rem;
}
</style>